import React, { useCallback, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-switch-lang';
import { Route } from 'react-router';
import usersStorage from './usersStorage';
import EditProfile from './EditProfile';
import UsersList from './UsersList';

function UsersPage({ t }) {
  useEffect(() => {
    if (usersStorage.users.length == 0) usersStorage.loadDataFromServer();
  }, []);

  return (
    <>
      <Route path="/app/users" exact component={UsersList} />
      <Route path="/app/users/editProfile" component={EditProfile} />
      <Route path="/app/users/details/:id" component={EditProfile} />
      <Route path="/app/users/add" component={EditProfile} />
    </>
  );
}

UsersPage.propTypes = {};

export default translate(observer(UsersPage));
